import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog, PageEvent, MatPaginator } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { TipoArquivo } from 'src/app/models/enum';
import { Filtro } from 'src/app/models/filtro';
import { ModeloDownloadAnexo } from 'src/app/models/modelo-download-anexo';
import { ArquivoService } from 'src/app/services/arquivo.service';
import { CarregandoService } from 'src/app/services/carregando.service';
import { ModeloDownloadAnexoService } from 'src/app/services/modelo-download-anexo.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { PaginatorService } from 'src/app/services/paginator.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';

@Component({
  selector: 'app-modelos-de-download-modal',
  templateUrl: './modelos-de-download-modal.component.html',
  styleUrls: ['./modelos-de-download-modal.component.scss']
})
export class ModelosDeDownloadModalComponent implements OnInit {
  public config: PerfectScrollbarConfigInterface = {};
  modeloDownloadFiltrados: ModeloDownloadAnexo[] = [];
  carregando = true;
  campoOrdenacao = 'descricao';
  ordenarDesc = false;
  editavel = true;
  paginacao;
  listaDeItensPorPagina;
  itensPorPagina;
  filtroNome: Filtro = { Propriedade: 'nome', Valor: '' };
  filtros: Filtro[] = [this.filtroNome];

  @ViewChild('paginatorAnexo', { static: false }) paginator: MatPaginator;

  constructor(private utilitarioService: UtilitarioService, private arquivoService: ArquivoService, private modeloDownloadAnexoService: ModeloDownloadAnexoService, public dialogRef: MatDialogRef<ModelosDeDownloadModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, public dialog: MatDialog, private carregandoService: CarregandoService, private notificacaoService: NotificacaoService,
    private paginatorService: PaginatorService) { }

  ngOnInit(): void {
    const pagination = this.paginatorService.consultarPaginacao();
    
    this.paginacao = pagination.paginacao;
    this.itensPorPagina = pagination.itensPorPagina;
    this.listaDeItensPorPagina = pagination.listaDeItensPorPagina;

    this.buscarModelosDownload();
  }

  fechar() {
    this.dialogRef.close();
  }
  ordena(campo) {
    if (campo) {
      this.campoOrdenacao = campo;
      this.ordenarDesc = !this.ordenarDesc;

      this.mudaDePagina({ length: this.paginator.length, pageIndex: this.paginator.pageIndex, pageSize: this.paginator.pageSize });
    }

    return false;
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    if (typeof a === 'string') {
      a = a.toLowerCase();
    }

    if (typeof b === 'string') {
      b = b.toLowerCase();
    }

    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  filtra() {
    this.buscarModelosDownload();
    this.paginator.firstPage();
  }

  buscarModelosDownload() {
    this.carregandoService.mostra('buscarModelosDownload');
    this.carregando = true;

    this.modeloDownloadAnexoService.consultarModeloDownloadAnexosComPaginacao(this.filtroNome.Valor, this.paginacao.paginaAtual, this.itensPorPagina,
      this.campoOrdenacao, this.ordenarDesc ? 'desc' : 'asc').subscribe(dados => {
      this.modeloDownloadFiltrados = dados.itens;

      if (this.itensPorPagina > this.listaDeItensPorPagina[this.listaDeItensPorPagina.length - 1]) {
        this.itensPorPagina = 10;
      }

      this.paginacao.total = dados.total;

      this.carregando = false;
      this.carregandoService.esconde('buscarModelosDownload');
    }, (erro) => {
      this.carregandoService.esconde('buscarModelosDownload');
      this.notificacaoService.erro(erro);
    });
  }

  baixarArquivo(anexo: ModeloDownloadAnexo) {
    this.carregandoService.mostra('baixarArquivo');
    this.arquivoService.baixarArquivo(anexo.id, TipoArquivo.ModeloDownload).subscribe(arq => {
      this.utilitarioService.saveBlob(arq, anexo.arquivo);
      this.carregandoService.esconde('baixarArquivo');
    }, (erro) => {
      this.carregandoService.esconde('baixarArquivo');
      this.notificacaoService.erro(erro);
    });
  }

  mudaDePagina(pageEvent: PageEvent) {
    if (this.itensPorPagina !== pageEvent.pageSize)
      this.paginatorService.salvaPaginacao(pageEvent.pageSize);

    this.itensPorPagina = pageEvent.pageSize;
    this.paginacao.paginaAtual = pageEvent.pageIndex + 1;

    this.buscarModelosDownload();
  }
}